import React from 'react';
import AnimationRevealPage from 'helpers/AnimationRevealPage.js';
import MapComponent from '../components/Cart/MapComponent';
import { Container, ContentWithPaddingXl } from 'components/misc/Layouts';
import tw from 'twin.macro';

export default () => {
	const Title = tw.h2`text-2xl font-bold text-left mb-8`;
	const Intro = tw.p`mb-4 text-gray-700`;
	const Highlight = tw.p`mb-6 font-semibold text-gray-800`;

	return (
		<AnimationRevealPage>
			<Container>
				<ContentWithPaddingXl>
					<Title> ENVÍOS </Title>
					<Intro>Los envíos se realizan de lunes a viernes entre 18 y 21 hs.</Intro>
					<Highlight>
						Al realizar la compra web nosotros nos estaremos comunicando contigo para coordinar el envío y
						forma de pago!
					</Highlight>
					<MapComponent onDireccionSeleccionada={() => {}} enviosPage />
				</ContentWithPaddingXl>
			</Container>
		</AnimationRevealPage>
	);
};
